module.exports = __webpack_public_path__ + "static/media/fitbit-connected.860316f7.png";